export default class formConfig {
  // 招标内容详情
  static configList() {
    return [
      {
        title: "招标内容详情",
        name: "1",
        icon: "",
        formConfigList: [
          {
            label: "招标内容：",
            type: "input",
            value: "tenderContent",
            placeholder: "请输入",
            maxlength: 200,
            rule: {
              required: true,
              message: "请填写招标内容",
              trigger: "blur"
            }
          },
          {
            label: "招标内容编码：",
            type: "input",
            value: "tenderContentNum",
            placeholder: "请输入",
            maxlength: 200,
            rule: {
              required: false,
              message: "请填写招标内容编码",
              trigger: "blur"
            }
          },
          {
            label: "招标类别：",
            type: "select",
            value: "tenderClassNum",
            placeholder: "请输入",
            queryParams: {
              url: "/dataDictionaryEntries/DictionaryCombobox",
              zdid: "201510200918460003"
            },
            rule: {
              required: true,
              message: "请选择招标类别",
              trigger: "blur"
            }
          },
          {
            label: "直接发包备案项目内容标志：",
            type: "radio",
            value: "flag",
            required: true,
            rule: {
              required: true,
              message: "请选择直接发包备案项目内容标志",
              trigger: "blur"
            },
            option: [
              {
                label: "是",
                value: "0"
              },
              {
                label: "否",
                value: "1"
              }
            ]
          },
        ]
      },
    ];
  }
}
